import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { loyaltyLinks } from "@/components/lib/SidebarLinks";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "@/hooks/useAuth";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import useDebounce from "@/hooks/useDebounce";
import ConcessionTab from "@/components/loyalty/concession/ConcessionTab";
import { fetchConcessions } from "@/redux/slice/loyalty/ConcessionSlice";

function Concession() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  
  const { search, getLoading, status, perPage, currentPage } = useSelector(
    (state) => state.loyalty.concession
  );
  const debouncedSearch = useDebounce(search, 900);

  useEffect(() => {
    const query = {
      page: currentPage,
      per_page: perPage,
      search: debouncedSearch,
      restaurant_id: user?.restaurant_id,
    };

    if (status && status !== "0") {
      query.status = status;
    }

    dispatch(fetchConcessions(query));
  }, [currentPage, debouncedSearch, status]);

  if (getLoading) return <TableSkeleton links={loyaltyLinks} />;

  return (
    <Layout2
      pageName={{ title: "Concession" }}
      paths={[
        { name: "home", path: "/home" },
        { name: "Loyalty", path: "/loyalty" },
        { name: "Concession", path: "/loyalty/concession" },
      ]}
      LeftBar={<LeftBar2 sidebarLinks={loyaltyLinks} />}
    >
      <div className="container flex flex-col gap-4 mt-5">
        {/* <div className="flex justify-end items-start md:items-center md:flex-row flex-col  w-full">
          <Link to={"/loyalty/concession/add"}>
            <Button>
              <Plus /> Create Concession
            </Button>
          </Link>
        </div> */}
        <Tabs valueKey="concession" className="bg-transparent relative" defaultValue="concession">
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            <TabsTrigger className="bg-transparent" value="concession">
              Concession
            </TabsTrigger>
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          <ConcessionTab />
        </Tabs>
      </div>
    </Layout2>
  );
}

export default Concession;
